import { NgModule } from '@angular/core'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSelectModule } from '@angular/material/select'
import { MatSnackBarModule } from '@angular/material/snack-bar'

// the material modules used by eagerly loaded code (public pages and SharedModule's components):
// contact form (form field, input, select, spinner) and snack bars (contact, footer, breadcrumbs).
// lazily loaded features import CoreMaterialModule (all of material) themselves, so material
// doesn't weigh on every page
@NgModule({
  exports: [
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSnackBarModule,
  ]
})
export class PublicMaterialModule {}
